import { eachDayOfInterval } from 'date-fns';
import { isBefore, startOfDay } from './date';

export function getCurrentAndFutureUnavailabilityDays(
  range: { start: string; end: string },
  today = startOfDay(new Date()),
): Date[] {
  return eachDayOfInterval({
    start: new Date(range.start),
    end: new Date(range.end),
  }).filter((date) => !isBefore(date, today));
}

export function getActiveUnavailabilityRange(
  unavailability: unknown,
  now = new Date(),
): { start: Date; end: Date } | null {
  if (!Array.isArray(unavailability)) {
    return null;
  }

  for (const range of unavailability) {
    if (!range || typeof range !== 'object') {
      continue;
    }

    const startRaw = (range as { start?: unknown }).start;
    const endRaw = (range as { end?: unknown }).end;

    if (typeof startRaw !== 'string' && typeof startRaw !== 'number' && !(startRaw instanceof Date)) {
      continue;
    }
    if (typeof endRaw !== 'string' && typeof endRaw !== 'number' && !(endRaw instanceof Date)) {
      continue;
    }

    const start = new Date(startRaw);
    const end = new Date(endRaw);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      continue;
    }

    if (start <= now && now <= end) {
      return { start, end };
    }
  }

  return null;
}

export function isCurrentlyUnavailable(unavailability: unknown, now = new Date()): boolean {
  return getActiveUnavailabilityRange(unavailability, now) !== null;
}
